import React from 'react';
import { Link } from 'react-router-dom';

class PageList extends React.Component {

    render() {
        const {
            pages,
            page,
            getURL,
            onClick
        } = this.props;
        
        if (pages.length > 0) {
            return (
                <ul className="nav nav-pills page-list">
                    {pages.map(p =>
                        <li key={p.id || 'none'} className="nav-item">
                            <Link to={getURL ? getURL(p.id == '#' ? '%23' : p.id) : '#'} onClick={onClick ? onClick.bind(this, p) : null} className={`nav-link ${(p.id == page ? 'active' : '')}`}>
                                {p.label}
                            </Link>
                        </li>
                    )}
                </ul>
            );
        }
        
        return null;
    }

}

export default PageList;